export default function formatCurrency(amount, symbol = true, code = false) {
  if (isNaN(amount)) amount = 0;
  return `${symbol ? `${this.$currency.symbol} ` : ""}${parseFloat(amount)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}${code ? this.$currency.code : ""}`;
}
